type NativeShareData = {
  title?: string;
  text?: string;
  url?: string;
  files?: File[];
};

function canShareFiles(files: File[]): boolean {
  const nav = navigator as Navigator & { canShare?: (data: NativeShareData) => boolean };
  if (typeof nav.canShare !== 'function') return false;
  try {
    return nav.canShare({ files });
  } catch {
    return false;
  }
}

export async function sharePreviewNative(opts: {
  title: string;
  text: string;
  url: string;
  audioUrl?: string;
}): Promise<'shared' | 'copied' | 'whatsapp'> {
  const payload: NativeShareData = {
    title: opts.title,
    text: opts.text,
    url: opts.url,
  };

  if (opts.audioUrl && typeof navigator.share === 'function') {
    try {
      const response = await fetch(opts.audioUrl);
      const blob = await response.blob();
      const file = new File([blob], 'previa.mp3', { type: blob.type || 'audio/mpeg' });
      if (canShareFiles([file])) {
        await navigator.share({ ...payload, files: [file] });
        return 'shared';
      }
    } catch {
      // Cai no share de texto/URL.
    }
  }

  if (typeof navigator.share === 'function') {
    try {
      await navigator.share(payload);
      return 'shared';
    } catch (error) {
      if ((error as DOMException)?.name === 'AbortError') throw error;
    }
  }

  try {
    await navigator.clipboard.writeText(`${opts.text} ${opts.url}`.trim());
    return 'copied';
  } catch {
    const wa = `https://wa.me/?text=${encodeURIComponent(`${opts.text} ${opts.url}`.trim())}`;
    window.open(wa, '_blank', 'noopener,noreferrer');
    return 'whatsapp';
  }
}
